import { WORKFLOWS_ACTION_MESSAGES_TYPES } from 'src/pages/ConfigurationPage/WorkflowsTab/constants';

export const getWorkflowRequestAction = (data: any) => {
  const action: Record<string, any> = {
    type: data.action_type === 'escalate' ? data.action_escalated_list : data.action_type,
  };

  if (action.type === 'handle_with_crm') {
    return action;
  }

  if (WORKFLOWS_ACTION_MESSAGES_TYPES.includes(action.type)) {
    action.message = data.action_message;

    return action;
  }

  if (action.type === 'close') {
    action.message = data.message_close;

    return action;
  }

  if (['collect_and_escalate', 'forward_to_email'].includes(action.type)) {
    action.message_before = data.message_before;
    action.message_after = data.message_after;
    action.fields = [];

    if (data.action_fields_name) {
      action.fields.push({
        type: 'name',
      });
    }

    if (data.action_fields_email) {
      action.fields.push({
        type: 'email',
      });
    }

    if (data.action_fields_phone_number) {
      action.fields.push({
        type: 'phone_number',
      });
    }

    if (
      data.action_fields_custom &&
      data.action_fields_custom_array &&
      data.action_fields_custom_array.length
    ) {
      data.action_fields_custom_array.forEach((field) => {
        action.fields.push({
          type: 'custom',
          ...field,
        });
      });
    }

    if (action.type === 'forward_to_email') {
      action.message_type = data.action_message_type;

      if (typeof data.sender_name !== 'undefined') {
        action.sender_name = data.sender_name;
      }

      if (typeof data.subject !== 'undefined') {
        action.subject = data.subject;
      }

      if (typeof data.sender_email_address !== 'undefined') {
        action.sender_email_address = data.sender_email_address;
      }

      action.receiver_email_addresses = data.receiver_email_addresses
        .split(',')
        .map((item) => item.trim())
        .filter(Boolean);
    }

    return action;
  }

  return action;
};
